
// Loading indicator component
import React from "react";

const LoadingIndicator: React.FC = () => (
    <div className="LoadingIndicator" style={{ textAlign: "center", padding: "20px 0" }}>
        <div className="LoadingBar" style={{
            width: "50%",
            height: "4px",
            margin: "0 auto",
            background: "#f0f0f0",
            borderRadius: "2px",
            overflow: "hidden",
            position: "relative"
        }}>
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "30%",
                background: "#307bb9",
                borderRadius: "2px",
                animation: "loading 1.5s infinite ease-in-out"
            }}></div>
        </div>
        <style>{`
      @keyframes loading {
        0% { left: -30%; }
        100% { left: 100%; }
      }
    `}</style>
        <p style={{ marginTop: "10px", color: "#666" }}>Loading data...</p>
    </div>
);
export default LoadingIndicator;